import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';

const ExternalUrlLoader = ({ url, onClose }) => {
  if (!url) return null;

  return ReactDOM.createPortal(
    <Overlay>
      <CloseButton onClick={onClose}>×</CloseButton>
      <Iframe src={url} title="External Content" />
    </Overlay>,
    document.body
  );
};

export default ExternalUrlLoader;

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: white;
  z-index: 9999;
`;

const Iframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  background-color: white;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 2vh;
  right: 2vw;
  z-index: 10000;
  font-size: 60px;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  border: none;
  border-radius: 50%;
  width: 5rem;
  height: 5rem;
  line-height: 1;
  cursor: pointer;
`;

